[
  {
    "key": "scholar",
    "name": "Scholar",
    "plural": "Scholars",
    "yields": {
      "science": 2,
      "gold": 0,
      "contentment": 0
    },
    "description": "Copies texts, keeps records and argues. Two science a turn, raised further by the city's libraries."
  },
  {
    "key": "merchant",
    "name": "Merchant",
    "plural": "Merchants",
    "yields": {
      "science": 0,
      "gold": 2,
      "contentment": 0
    },
    "description": "Buys, sells and lends. Two gold a turn straight to the treasury, untouched by the science slider."
  },
  {
    "key": "entertainer",
    "name": "Entertainer",
    "plural": "Entertainers",
    "yields": {
      "science": 0,
      "gold": 0,
      "contentment": 2
    },
    "description": "Musicians, players and storytellers. Each keeps two of the city's people content."
  }
]
